import { useBreakpoints } from '@design-system/breakpointsStore';
import { CSSProperties } from 'react';
import { FormRowsProps } from './FormRows';

export const useRowStyle = (
  p: Pick<FormRowsProps, 'styleSchema'>,
): CSSProperties => {
  const br = useBreakpoints();

  const getColumnWidth = (width?: string | number) => {
    if (typeof width === 'number') return `${width}px`;
    return width || '1fr';
  };

  const getGridColumns = () => {
    if (br.mobile) return ['1fr'];
    return p.styleSchema
      .map((r) => r.width)
      .map((w) => `minmax(0, ${getColumnWidth(w)})`);
  };

  return {
    display: 'grid',
    gridTemplateColumns: getGridColumns().join(' '),
    width: '100%',
    minWidth: 0,
    alignItems: 'center',
  };
};
